import script from "./HeaderMessagesButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMessagesButton.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMessagesButton.vue?vue&type=style&index=0&id=65ab751e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ab751e"]])

export default __exports__